import { CommunicationsScreenKey } from './communications.model';

export const COMMUNICATIONS_SOURCE = 'web';

export const COMMUNICATIONS_FIRESTORE_SUFFIX = '_communication_web';

export const getCommunicationsFirestoreField = (teamId: number | string): string =>
  `${teamId}${COMMUNICATIONS_FIRESTORE_SUFFIX}`;

export const COMMUNICATIONS_CTA_TYPES = {
  DEEPLINK: 'DEEPLINK',
  URL: 'URL',
  EXTERNAL_URL: 'EXTERNAL_URL',
  DETAILS: 'DETAILS'
} as const;

export const COMMUNICATIONS_PRESENTATION = {
  TOAST: 'TOAST',
  DIALOG: 'DIALOG'
} as const;

export const COMMUNICATIONS_POPUP_REPEAT = {
  ONCE: 'once',
  REPEATED: 'repeated'
} as const;

export const WEB_ROUTE_SCREEN_KEYS: CommunicationsScreenKey[] = [
  'HOME',
  'BALANCE',
  'DISPUTE',
  'PAYMENT_LIMITS',
  'PAYMENT_METHODS',
  'COLLECT_PAYMENT',
  'CARD_ON_FILE',
  'MANUAL_KEY_IN',
  'INVOICE_COLLECT_LINK',
  'RECORD_PAYMENT',
  'REFUND_CREATE',
  'REFUND_CONFIRM',
  'INVOICE_CREATE',
  'ESTIMATE_CREATE',
  'JOB_CREATE',
  'CREATE_TEAM'
];
